import { useEffect, useState } from 'react';

import get from 'lodash/get';

import CommonData from 'app/src/data/CommonData';
import PaymentProvider from 'app/src/payments/PaymentProvider';

export interface GatewayParameters {
  isTippingEnabled: boolean;
  isSurchargeEnabled: boolean;
}

const POLL_INTERVAL_MS = 200;
const POLL_MAX_ATTEMPTS = 25; // 5 seconds total

const useGatewayParameters = (): GatewayParameters => {
  const [isTippingEnabled, setIsTippingEnabled] = useState(false);
  const [isSurchargeEnabled, setIsSurchargeEnabled] = useState(false);

  useEffect(() => {
    let attempts = 0;
    let intervalId: ReturnType<typeof setInterval>;

    const tryFetch = () => {
      if (!CommonData.selectedShop) {
        attempts += 1;
        if (attempts >= POLL_MAX_ATTEMPTS) {
          clearInterval(intervalId);
        }
        return;
      }

      clearInterval(intervalId);

      PaymentProvider.getCurrentShopPaymentProvider()
        .then((paymentProvider: any) => {
          const tippingParam = get(
            paymentProvider,
            'activeGateway.attributes.parameters.terminalTippingEnabled',
            false
          );
          const surchargeParam = parseFloat(
            get(paymentProvider, 'activeGateway.attributes.parameters.surcharge', '0')
          );

          setIsTippingEnabled(tippingParam === true || tippingParam === 'true');
          setIsSurchargeEnabled(surchargeParam > 0);
        })
        .catch(() => {
          // If unable to fetch gateway config, default to no disclaimer shown
        });
    };

    intervalId = setInterval(tryFetch, POLL_INTERVAL_MS);
    tryFetch(); // also try immediately

    return () => clearInterval(intervalId);
  }, []);

  return { isTippingEnabled, isSurchargeEnabled };
};

export default useGatewayParameters;
